import {connect} from "react-redux";
import {CButton, CCol, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {Loading} from "../../../components/common";
import {AgGridReact} from "ag-grid-react";
import React, {useEffect, useMemo, useRef, useState} from "react";
import * as o2Api from "../../../api/api";
import axios from "axios";

const StoreCorner = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const gridStyle = useMemo(() => ({height: "100%", width: "100%"}), []);

	const {info} = props;
	const [loading, setLoading] = useState(false);
	const [rowData, setRowData] = useState([]);
	const [vanList, setVanList] = useState([]);

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	}

	const [columnDefs] = useState([
		{
			field: "cornerCd",
			headerName: "코드",
			editable: true,
			headerCheckboxSelection: true,
			checkboxSelection: true,
			showDisabledCheckboxes: true
		},
		{field: "cornerNm", headerName: "코너명", editable: true},
		{field: "erpCd", headerName: "ERP코드", editable: true},
		{field: "useYn", headerName: "사용여부"}
	]);

	useEffect(() => {
		if (info.busiNo.length > 0 && info.storeCd !== null) {
			getData();
		}
	}, [info]);

	const getData = () => {
		getStoreVan(info);
		getStoreCornerList(info);
	}

	const getStoreCornerList = (param) => {
		const params = {
			storeCd: param.storeCd,
			brandCd: param.brandCd,
			cmpCd: param.cmpCd,
			erpCd: param.erpCd
		};
		let resultValue = [];

		setLoading(true);
		try {
			o2Api.getStoreCorner(params).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					setRowData(responseBody);
				}
			});
		} catch (e) {
			console.error(e.message);
		} finally {
			setLoading(false);
		}
	};

	const getStoreVan = (param) => {
		const params = {
			storeCd: param.storeCd,
			brandCd: param.brandCd,
			cmpCd: param.cmpCd
		};

		setLoading(true);
		try {
			o2Api.getStoreVan(params).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					setVanList(responseBody);
				}
			});
		} catch (e) {
			console.error(e.message);
		} finally {
			setLoading(false);
		}
	};

	const setNewData = () => {
		const newData = {
			cmpCd: info.cmpCd,
			brandCd: info.brandCd,
			storeCd: info.storeCd,
			cornerCd: "",
			cornerNm: "",
			erpCd: "",
			useYn: "Y"
		};
		setRowData((state) => {
			return [...state, newData];
		});
	};

	const save = () => {
		if (confirm("저장하시겠습니까?")) {
			const {api} = gridRef.current;
			if (api === null) return;

			const selectRows = api.getSelectedRows();
			if (selectRows.length > 0) {
				selectRows.map((item) => {
					if (item.cornerCd.length === 0) {
						alert("코너코드는 필수로 입력하셔야 합니다.");
						return;
					}
				});
			} else {
				return;
			}

			setLoading(true);
			try {
				o2Api.putStoreCorner(selectRows).then((result) => {
					const {responseBody, responseCode, responseMessage} = result.data;
					if (responseCode === "200") {
						// 성공
						alert("처리되었습니다.");
						getStoreCornerList(info);
					} else {

					}
				});
			} catch (e) {
				console.error(e.message);
			} finally {
				setLoading(false);
			}
		}
	};
	const deleteCorner = () => {

		const {api} = gridRef.current;
		if (api === null) return;

		const selectRows = api.getSelectedRows();
		if (selectRows.length > 0) {
			if (confirm("선택한 코너정보를 삭제하시겠습니까?")) {
				console.log("row : ", JSON.stringify(selectRows));

				setLoading(true);
				try {
					o2Api.deleteStoreCorner(selectRows).then((result) => {
						const {responseBody, responseCode, responseMessage} = result.data;
						if (responseCode === "200") {
							// 성공
							alert("정상처리 되었습니다.");
							getStoreCornerList(info);
						}
					});
				} catch (e) {
					console.error(e.message);
				} finally {
					setLoading(false);

				}
			}
		}
	}

	const getCatId = () => {
		setLoading(true);

		const backOfficeUrl = process.env["REACT_APP_VAN_BO"];
		const backOfficeToken = process.env["REACT_APP_VAN_TOKEN"];
		axios.post(backOfficeUrl, {
			taxno: info.busiNo,
			taxidx: info.taxidx
		}, {
			headers: {
				"Authorization": backOfficeToken,
				"Content-Type": "application/json"
			}
		}).then((result) => {
			setLoading(false);
			const {header, body} = result.data;
			if (header.resCode === "S0000") {
				console.log("##3 body :: ", body.dsTerminal);
			}
			else {
				window.alert(header.resCode + "\n" + header.resMsg);
			}
		})
			.catch(ex => {
				window.alert("서버에 문제가 있습니다. 관리자에게 문의 해주세요.\n" + ex.message);
			})
	}

	const putStoreVan = () => {
	    if (window.confirm("VAN 정보를 갱신하시겠어요?")) {
			setLoading(true);
			const params = {
				cmpCd: info.cmpCd,
				brandCd: info.brandCd,
				storeCd: info.storeCd,
				taxno: info.busiNo,
				taxidx: info.taxidx,
				requestUserId: 'admin'
			}
			o2Api.putStoreVan(params).then(result => {
				const {responseCode, responseMessage, responseBody} = result.data;
				if (responseCode === "200") {
					getData();
				}
				else {
					window.alert(responseCode + "\n" + responseMessage);
				}
			})
				.catch(ex => {
					window.alert(ex.message)
				})
				.finally(() => {
					setLoading(false);
				})
		}
	}

	return (
		<>
			<CRow>
				<div className="ag-theme-alpine" style={gridStyle}>
					{loading ? <Loading/> : null}
					<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
						<h5>VAN설정</h5>
						<div className={"d-grid d-lg-flex gap-1"}>
							<button className={"px-2 rounded border-1"} onClick={putStoreVan}>발급</button>
						</div>
					</div>

					<table style={{width: "100%", borderWidth: 1, borderStyle: "solid", borderColor: "#ccc"}}>
						<tr style={{
							borderWidth: 1,
							height: 40,
							borderStyle: "solid",
							borderColor: "#ccc",
							alignItems: "center"
						}}>
							<th style={{
								borderWidth: 1,
								borderStyle: "solid",
								borderColor: "#ccc",
								background: "#efefef"
							}}/>
							<th style={{
								borderWidth: 1,
								borderStyle: "solid",
								borderColor: "#ccc",
								alignItems: "center",
								background: "#efefef"
							}}>VAN사
							</th>
							<th style={{
								borderWidth: 1,
								borderStyle: "solid",
								borderColor: "#ccc",
								alignItems: "center",
								background: "#efefef"
							}}>CAT-ID
							</th>
						</tr>
						{vanList.length > 0 && vanList.map((item) => {
							return (
								<tr style={{borderWidth: 1, height: 40, borderStyle: "solid", borderColor: "#ccc"}}>
									<td style={{
										borderWidth: 1,
										height: 20,
										borderStyle: "solid",
										borderColor: "#ccc",
										background: "#efefef"
									}}><strong>기본</strong></td>
									<td style={{
										borderWidth: 1,
										height: 20,
										borderStyle: "solid",
										borderColor: "#ccc"
									}}>Secta9ine
									</td>
									<td
										style={{
											borderWidth: 1,
											height: 20,
											borderStyle: "solid",
											borderColor: "#ccc"
										}}>{item.catId}</td>
								</tr>
							);
						})}
					</table>
					<div style={{height: 20}}/>
					<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
						<h5>매장코너</h5>
						<div>
							<CButton style={{marginRight: 10}} size={"sm"} onClick={setNewData}>신규</CButton>
							<CButton style={{marginRight: 10}} size={"sm"} onClick={save}>저장</CButton>
							<CButton size={"sm"} onClick={deleteCorner}>삭제</CButton>
						</div>
					</div>
					<AgGridReact
						ref={gridRef}
						domLayout={"autoHeight"}
						rowSelection={"multiple"}
						rowData={rowData}
						animateRows={true}
						defaultColDef={defaultColDef}
						columnDefs={columnDefs}>
					</AgGridReact>
				</div>
			</CRow>
		</>
	);
};

StoreCorner.defaultProps = {
	info: {}
};

const mapStateToProps = (state) => {
	const {account, store} = state;
	return {
		account, store
	};
};

export default connect(mapStateToProps, null)(StoreCorner);
